import React from "react";
import { Link } from "react-router-dom";
import "./adminDashboard.css";

export default function DashboardVolunteersCard({ items, loading }) {
  const list = items || [];

  return (
    <div className="adminCard">
      <div className="adminCardHeader">
        <h3 className="adminCardTitle">Volunteers</h3>
        <Link to="/admin/volunteers" className="adminButton">
          View all
        </Link>
      </div>
      <div className="adminCardBody adminDashPreviewBody">
        {loading ? (
          <div className="adminList">
            {[0, 1, 2, 3].map((i) => (
              <div key={i} className="adminDashPreviewRow" aria-hidden="true">
                <div className="adminSkeleton" style={{ width: "50%", height: 12 }} />
                <div className="adminSkeleton" style={{ width: "65%", marginTop: 8, height: 10 }} />
              </div>
            ))}
          </div>
        ) : list.length === 0 ? (
          <div className="adminEmpty adminDashPreviewEmpty">No applications yet.</div>
        ) : (
          <div className="adminList">
            {list.map((v) => (
              <div key={v.id} className="adminDashPreviewRow">
                <div className="adminDashPreviewTop">
                  <span className="adminDashPreviewName">{v.name}</span>
                  <span className="adminDashPreviewDate">{v._displayDate}</span>
                </div>
                <div className="adminDashPreviewMeta">
                  <span className="adminDashPreviewPill">{v.areaOfInterest}</span>
                  <span className="adminDashPreviewEmailInline">{v.email}</span>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
